import { render, staticRenderFns } from "./form-versions.vue?vue&type=template&id=fd3ed86c&scoped=true&"
import script from "./form-versions.vue?vue&type=script&lang=js&"
export * from "./form-versions.vue?vue&type=script&lang=js&"
import style0 from "./form-versions.vue?vue&type=style&index=0&id=fd3ed86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3ed86c",
  null
  
)

component.options.__file = "form-versions.vue"
export default component.exports